<app-modal-form #modalForm [modalConfig]="modalConfig">
  <!-- SELECTED CHIPS -->
  <div *ngIf="listSelectedItems | async as listSelected" class="mb-4">
    <app-chips-legacy [chipsList]="listSelected" (dataOutput)="handleDataOutput($event)" [labelTextStyle]="'uppercase'"></app-chips-legacy>

    <div class="mt-6" *ngIf="!numOfSelectedChipsIsValid()">
      <app-note-view [color]="'warning'" [icon]="STRING_CONSTANTS.ICON.IC_ORANGE_WARNING" [text]="'Maksimal produk per-batch sudah terpenuhi!'"></app-note-view>
    </div>
  </div>

  <ng-container *ngIf="listItems | async as listItems; else noDataTpl">
    <div class="multiselect-search mb-4">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Silahkan cari brand disini" [(ngModel)]="searchKeyword" />
        <span class="input-group-text">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_SEARCH" class="svg-icon svg-icon-2"></span>
        </span>
      </div>
    </div>

    <div class="multiselect-list mh-200px overflow-auto mb-4">
      <ng-template #selectListTpl>
        <div class="form-check my-6 text-capitalize" *ngFor="let item of listItems | filter : searchKeyword : { key: 'name' }">
          <fieldset [disabled]="!numOfSelectedChipsIsValid()">
            <input type="checkbox" class="form-check-input cursor-pointer" id="flexCheckDefault-{{ item.id }}" (change)="handleChangeSelection()" [(ngModel)]="item.selected" />
            <div class="d-flex align-items-center">
              <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-uppercase">
                {{ item.name | lowercase }}
              </label>
              <span class="ms-4 badge badge-bg badge__status badge__status--{{ item['status'] }}">
                {{ item['status_value'] }}
              </span>
            </div>
          </fieldset>
        </div>

        <ng-container *ngIf="(listItems | filter : searchKeyword : { key: 'name' }).length < 1">
          <ng-template [ngTemplateOutlet]="noDataTpl"></ng-template>
        </ng-container>
      </ng-template>

      <ng-container *ngIf="loading | async; else selectListTpl">
        <ng-template [ngTemplateOutlet]="listLoader"></ng-template>
      </ng-container>
    </div>

    <div class="d-flex justify-content-end">
      <button
        class="btn btn-primary min-w-150px"
        type="button"
        mat-raised-button
        color="primary"
        [disabled]="!(listSelectedItems | async)?.length || loading.value"
        (click)="handleAddItems()"
      >
        <div class="d-flex align-items-center">
          <span>{{ ctaLabel }}</span>
          <span *ngIf="loading.value" class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </div>
      </button>
    </div>
  </ng-container>

  <ng-template #noDataTpl>
    <p>Tidak ada data...</p>
  </ng-template>
</app-modal-form>

<ng-template #listLoader>
  <app-input-listbox-loader></app-input-listbox-loader>
</ng-template>
